export interface FeedbackRequestData {
  name: string;
  email: string;
  desiredMonthlyTrackGenerations: string;
  additionalInformation: string;
}
